import { render, staticRenderFns } from "./Wap.vue?vue&type=template&id=58314cdb&scoped=true&"
import script from "./Wap.vue?vue&type=script&lang=js&"
export * from "./Wap.vue?vue&type=script&lang=js&"
import style0 from "./Wap.vue?vue&type=style&index=0&id=58314cdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58314cdb",
  null
  
)

export default component.exports